<!-- gallery.component.html -->
<div class="page">

  <!-- ── Breadcrumb ───────────────────────────────────────────────────── -->
  <nav class="breadcrumb">
    <button
      *ngFor="let crumb of breadcrumbs; let last = last"
      class="crumb"
      [class.active]="last"
      (click)="!last && navigateTo(crumb)">
      {{ crumb.name }}
      <span class="sep" *ngIf="!last">›</span>
    </button>
  </nav>

  <div class="modal fade"
       id="linkSourceModal"
       tabindex="-1"
       aria-labelledby="linkSourceModalLabel"
       aria-hidden="true"
       data-bs-backdrop="static"
       data-bs-keyboard="false"></div>

  <!-- ── Toolbar ──────────────────────────────────────────────────────── -->
  <div class="toolbar">
    <div class="left">
      <h3>Gallery</h3>
      <div class="muted">الصور: <b>{{ totalCount }}</b></div>
    </div>

    <div class="right">

      <!-- ✅ زرار تحديث يدوي -->
      <button class="refresh-btn"
              (click)="refresh()"
              [disabled]="isLoading"
              title="تحديث القائمة">
        <i class="fa fa-rotate-right"
           [class.fa-spin]="isLoading"></i>
      </button>

      <input class="search" type="text" placeholder="بحث بالاسم..."
             [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" />

      <div class="tabs">
        <button class="tab" [class.active]="sortMode==='newest'" (click)="setSort('newest')">الأحدث</button>
        <button class="tab" [class.active]="sortMode==='oldest'" (click)="setSort('oldest')">الأقدم</button>
        <button class="tab" [class.active]="sortMode==='name'" (click)="setSort('name')">بالاسم</button>
      </div>

      <div class="view">
        <button class="icon" [class.active]="viewMode==='grid'" (click)="setView('grid')">🔳</button>
        <button class="icon" [class.active]="viewMode==='list'" (click)="setView('list')">📄</button>
      </div>

      <button class="btn primary icon-btn" (click)="openNewFolder()">
        <span><i class="fa fa-folder" aria-hidden="true"></i></span> فولدر جديد
      </button>

      <button class="btn primary icon-btn" (click)="openLinkModal()">
        <span><i class="fa fa-link" aria-hidden="true"></i></span> Link Uploads
      </button>
    </div>
  </div>

  <!-- ── Folders Row ───────────────────────────────────────────────────── -->
  <div class="folders-row" *ngIf="folders.length">
    <div class="folder-card" *ngFor="let folder of folders" (click)="openFolder(folder)">
      <div class="folder-icon">
        <span><i class="fa fa-folder" aria-hidden="true"></i></span>
        <span class="folder-arrow" *ngIf="folder.hasChildren">›</span>
      </div>
      <div class="folder-name" [title]="folder.name">{{ folder.name }}</div>
      <button class="folder-del" (click)="deleteFolder(folder); stop($event)" title="حذف الفولدر">🗑️</button>
    </div>
  </div>

  <!-- ── Upload zone ───────────────────────────────────────────────────── -->
  <div class="upload-zone"
       [class.dragover]="dragOver"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">

    <div class="upload-inner">
      <div class="title">اسحب الصور هنا أو اختر من جهازك</div>
      <div class="upload-path">
        📍 هيتم الرفع في: <b>/{{ currentPath || '(الجذر)' }}</b>
      </div>
      <div class="muted small">يدعم رفع صور متعددة مرة واحدة</div>

      <label class="pick-btn">
        <input type="file" accept="image/*" multiple
               (change)="onPickFiles($any($event.target).files)" hidden>
        اختيار صور
      </label>
    </div>

    <div class="progress" *ngIf="uploading">
      <div class="bar" [style.width.%]="uploadPct"></div>
      <div class="pct">{{ uploadPct }}%</div>
    </div>
  </div>

  <!-- ── Select bar ────────────────────────────────────────────────────── -->
  <div class="select-bar" *ngIf="selectedCount > 0">
    <div class="count">{{ selectedCount }} محدد</div>
    <div class="actions">
      <button class="btn" (click)="toggleSelectAll()">تحديد الكل</button>
      <button class="btn" (click)="clearSelection()">إلغاء التحديد</button>
      <button class="btn danger" (click)="deleteSelected()">حذف المحدد</button>
    </div>
  </div>

  <!-- ── Images section ────────────────────────────────────────────────── -->
  <div class="section-title" *ngIf="filtered.length">
    <span>الصور</span>
    <span class="muted small">
      {{ filtered.length }} صورة
      <ng-container *ngIf="totalPages > 0">
        — الصفحة {{ pageNumber }} من {{ totalPages }}
      </ng-container>
    </span>
  </div>

  <div class="grid" [class.list]="viewMode==='list'" *ngIf="filtered.length; else empty">
    <div class="card"
         *ngFor="let img of filtered; trackBy: trackById"
         [class.selected]="img.selected"
         (click)="toggleSelect(img.id!)">

      <div class="checkbox"></div>

      <div class="thumb" (click)="openLightbox(img); stop($event)">
        <!-- ✅ Blob URL أولاً، ثم الـ URL العادي -->
        <img [src]="img.displayUrl || (img.url | ImageUrlPipe : cacheBuster)"
             [alt]="img.name"
             loading="lazy">
        <div class="overlay">
          <button class="ov" (click)="openLightbox(img); stop($event)">👁️</button>
          <button class="ov" (click)="openEdit(img); stop($event)">✏️</button>
          <button class="ov danger" (click)="openDelete(img); stop($event)">🗑️</button>
        </div>
      </div>

      <div class="info">
        <div class="name" [title]="img.name">{{ img.name }}</div>
        <div class="meta">
          <span class="badge">{{ img.size }}</span>
          <span>{{ img.date | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="desc" *ngIf="viewMode==='list' && img.desc">{{ img.desc }}</div>
      </div>
    </div>
  </div>

  <!-- ── Pagination ────────────────────────────────────────────────────── -->

  <div class="pagination-container" *ngIf="totalPages > 0">
    <div class="pagination-info">
      Showing <strong>{{ getStartIndex() }}</strong> to <strong>{{ getEndIndex() }}</strong>
      of <strong>{{ totalCount }}</strong> combined orders
    </div>

    <div class="pagination-controls">
      <button
        class="page-btn prev-btn"
        (click)="prevPage()"
        [disabled]="pageNumber === 1 || isLoading"
      >
        ‹
      </button>

      <button
        *ngFor="let p of getPageNumbers()"
        class="page-btn page-number"
        [class.active]="p === pageNumber"
        [disabled]="isLoading"
        (click)="goToPage(p)"
      >
        {{ p }}
      </button>

      <button
        class="page-btn next-btn"
        (click)="nextPage()"
        [disabled]="pageNumber === totalPages || isLoading"
      >
        ›
      </button>
    </div>
  </div>



  <ng-template #empty>
    <div class="empty">
      <div *ngIf="folders.length; else noContent">
        <i class="fa fa-folder" aria-hidden="true"></i> افتح فولدر لعرض الصور، أو ارفع صور هنا مباشرة
      </div>
      <ng-template #noContent>
        مفيش صور — ارفع أول صورك 👆
      </ng-template>
    </div>
  </ng-template>

  <!-- ── Lightbox ──────────────────────────────────────────────────────── -->
  <div class="modal-backdrop" *ngIf="lightboxOpen" (click)="closeLightbox()"></div>
  <div class="modal" *ngIf="lightboxOpen">
    <div class="modal-head">
      <div class="modal-title">{{ active?.name }}</div>
      <button class="x" (click)="closeLightbox()">✖</button>
    </div>
    <div class="modal-body dark">
      <!-- ✅ Blob URL أولاً -->
      <img class="preview"
           [src]="active?.displayUrl || (active?.url | ImageUrlPipe : cacheBuster)"
           [alt]="active?.name">
      <div class="caption" *ngIf="active?.desc">{{ active?.desc }}</div>
    </div>
  </div>

  <!-- ── Edit modal ────────────────────────────────────────────────────── -->
  <div class="modal-backdrop" *ngIf="editOpen" (click)="closeEdit()"></div>
  <div class="modal sm" *ngIf="editOpen">
    <div class="modal-head">
      <div class="modal-title">تعديل الصورة</div>
      <button class="x" (click)="closeEdit()">✖</button>
    </div>
    <div class="modal-body">
      <!-- ✅ Blob URL أولاً -->
      <img class="edit-preview"
           [src]="active?.displayUrl || (active?.url | ImageUrlPipe : cacheBuster)"
           alt="preview">

      <label class="lbl">الاسم</label>
      <input class="inp" [(ngModel)]="active!.name">

      <label class="lbl">الوصف</label>
      <textarea class="inp" rows="3" [(ngModel)]="active!.desc"></textarea>

      <div class="row">
        <button class="btn" (click)="closeEdit()">إلغاء</button>
        <button class="btn primary" (click)="saveEdit()">حفظ</button>
      </div>
    </div>
  </div>

  <!-- ── Delete modal ──────────────────────────────────────────────────── -->
  <div class="modal-backdrop" *ngIf="deleteOpen" (click)="closeDelete()"></div>
  <div class="modal sm" *ngIf="deleteOpen">
    <div class="modal-head">
      <div class="modal-title">تأكيد الحذف</div>
      <button class="x" (click)="closeDelete()">✖</button>
    </div>
    <div class="modal-body">
      <p>هل تريد حذف: <b>{{ active?.name }}</b> ؟</p>
      <div class="row">
        <button class="btn" (click)="closeDelete()">إلغاء</button>
        <button class="btn danger" (click)="confirmDelete()">حذف</button>
      </div>
    </div>
  </div>

  <!-- ── New Folder modal ───────────────────────────────────────────────── -->
  <div class="modal-backdrop" *ngIf="newFolderOpen" (click)="closeNewFolder()"></div>
  <div class="modal sm" *ngIf="newFolderOpen">
    <div class="modal-head">
      <div class="modal-title">إنشاء فولدر جديد</div>
      <button class="x" (click)="closeNewFolder()">✖</button>
    </div>
    <div class="modal-body">
      <div class="muted small" style="margin-bottom:.75rem">
        داخل: <b>/uploads/{{ currentPath || '(الجذر)' }}</b>
      </div>

      <label class="lbl">اسم الفولدر</label>
      <input class="inp"
             [(ngModel)]="newFolderName"
             placeholder="مثال: products"
             (keyup.enter)="createFolder()">

      <div class="row">
        <button class="btn" (click)="closeNewFolder()">إلغاء</button>
        <button class="btn primary" (click)="createFolder()">إنشاء</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade"
     *ngIf="showLinkModal"
     id="linkSourceModal"
     tabindex="-1"
     aria-labelledby="linkSourceModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content custom-modal">

      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold" id="linkSourceModalLabel">Link Uploads</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          [disabled]="isLinking">
        </button>
      </div>

      <div class="modal-body pt-3">
        <div class="mb-3">
          <label class="form-label fw-semibold">Select Source</label>

          <select class="form-select custom-select"
                  [(ngModel)]="selectedSource"
                  [disabled]="isLinking">
            <option value="" disabled>Select source</option>
            <option value="product">Product</option>
            <option value="category">Category</option>
            <option value="brand">Brand</option>
          </select>
        </div>

        <div *ngIf="linkResult" class="alert alert-success py-2 mb-2">
          {{ linkResult }}
        </div>

        <div *ngIf="linkError" class="alert alert-danger py-2 mb-2">
          {{ linkError }}
        </div>
      </div>

      <div class="modal-footer border-0 pt-0">
        <button
          type="button"
          class="btn btn-light px-4"
          data-bs-dismiss="modal"
          (click)="closeLinkModal()"
          [disabled]="isLinking">
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-primary px-4 d-flex align-items-center gap-2"
          [disabled]="!selectedSource || isLinking"
          (click)="linkUploads()">
          <span *ngIf="isLinking"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"></span>
          <span>{{ isLinking ? 'Linking...' : 'Link' }}</span>
        </button>
      </div>

    </div>
  </div>
</div>